<template>
    <div class="teams-instructions-wrapper">
      <h1 class="page-title">Microsoft Teams Integration</h1>
  
      <div class="content-block">
        <p>Follow these steps to integrate Microsoft Teams with Makeping alerts using webhooks:</p>
  
        <ol>
          <li>
            Create a channel in Microsoft Teams where you want to receive alerts.
            <div class="step-image" @click="openModal(1)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-1.png')" alt="Step 1" />
            </div>
          </li>
          <hr />
          <li>
            Go to <a href="https://make.powerautomate.com/" target="_blank"><strong>Power Automate</strong></a>.
            <div class="step-image" @click="openModal(2)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-2.png')" alt="Step 2" />
            </div>
          </li>
          <hr />
          <li>
            Click on the <strong>“Create”</strong> option in the left sidebar.
            <div class="step-image" @click="openModal(3)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-3.png')" alt="Step 3" />
            </div>
          </li>
          <hr />
          <li>
            Search for <strong>“webhook”</strong> and press Enter.
            <div class="step-image" @click="openModal(4)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-4.png')" alt="Step 4" />
            </div>
          </li>
          <hr />
          <li>
            Select <strong>“Post to a channel when a webhook request is received.”</strong>
            <div class="step-image" @click="openModal(5)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-5.png')" alt="Step 5" />
            </div>
          </li>
          <hr />
          <li>
            Connect with your Teams org account. Once connected, click <strong>“Continue.”</strong>
            <div class="step-image" @click="openModal(6)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-6.png')" alt="Step 6" />
            </div>
          </li>
          <hr />
          <li>
            Select your <strong>Team</strong> and <strong>Channel</strong>, then click <strong>“Create.”</strong>
            <div class="step-image" @click="openModal(7)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-7.png')" alt="Step 7" />
            </div>
          </li>
          <hr />
          <li>
            Close the popup window after creation.
            <div class="step-image" @click="openModal(8)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-8.png')" alt="Step 8" />
            </div>
          </li>
          <hr />
          <li>
            Click on the <strong>“Edit”</strong> button to configure the webhook.
            <div class="step-image" @click="openModal(9)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-9.png')" alt="Step 9" />
            </div>
          </li>
          <hr />
          <li>
            Choose the first option from the list shown.
            <div class="step-image" @click="openModal(10)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-10.png')" alt="Step 10" />
            </div>
          </li>
          <hr />
          <li>
            Copy the generated webhook URL.
            <div class="step-image" @click="openModal(11)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-11.png')" alt="Step 11" />
            </div>
          </li>
        </ol>
        <br>
        <h3 class="section-title">Go to the <a :href="$router.resolve({ path: '/app/alertcontacts' }).href" target="_blank"><strong>Makeping Alerts</strong></a> page.</h3>
  
        <ol>
          <li>
            Click <strong>“Add New Alert”</strong> and choose <strong>“Teams”</strong> as the alert type (for selective plan users).
            <div class="step-image" @click="openModal(12)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-12.png')" alt="Step 12" />
            </div>
          </li>
          <hr />
          <li>
            Add a name and paste the copied webhook URL.
            <div class="step-image" @click="openModal(13)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-13.png')" alt="Step 13" />
            </div>
          </li>
          <hr />
          <li>
            Click <strong>“Send Verification Code”</strong> to confirm.
            <div class="step-image" @click="openModal(14)">
              <img :src="require('../../assets/images/Teams-instruction/Screenshot-14.png')" alt="Step 14" />
            </div>
          </li>
          <hr />
          <li>
             That’s it! Your webhook integration is now set up and ready to send alerts. 🎉
          </li>
        </ol>
      </div>
  
      <!-- Fullscreen Image Modal -->
      <div class="image-modal" v-if="activeImage" @click.self="activeImage = null">
        <div class="image-container">
          <span class="close-btn" @click="activeImage = null">&times;</span>
          <img :src="require(`../../assets/images/Teams-instruction/Screenshot-${activeImage}.png`)" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        activeImage: null
      }
    },
    methods: {
      openModal(index) {
        this.activeImage = index
      }
    }
  }
  </script>
  
  <style scoped>
  .teams-instructions-wrapper {
    max-width: 100%;
    padding: 40px 80px;
    background-color: #fff;
    color: #333;
    font-family: "Segoe UI", sans-serif;
  }
  
  .page-title {
    font-size: 2.5rem;
    font-weight: 600;
    margin-bottom: 30px;
    text-align: center;
  }
  
  .section-title {
    margin-top: 50px;
    font-size: 1.5rem;
    font-weight: 600;
    border-bottom: 2px solid #eee;
    padding-bottom: 10px;
  }
  
  .content-block p,
  .content-block ol {
    font-size: 1.2rem;
    line-height: 1.7;
    margin-bottom: 20px;
  }
  
  .content-block ol {
    padding-left: 20px;
  }
  
  .content-block ol li {
    margin-bottom: 30px;
  }
  
  .step-image {
    margin-top: 15px;
    margin-bottom: 10px;
    text-align: center;
    cursor: pointer;
  }
  
  .step-image img {
    width: 100%;
    max-width: 70%;
    height: auto;
    border-radius: 10px;
    transition: transform 0.2s;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
  }
  
  .step-image img:hover {
    transform: scale(1.02);
  }
  
  /* Image Modal */
  .image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .image-container {
    position: relative;
    max-width: 90%;
    max-height: 90%;
  }
  
  .image-container img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
  
  .close-btn {
    position: absolute;
    top: -40px;
    right: -30px;
    font-size: 2.2rem;
    color: #dc0000;
    cursor: pointer;
  }
  </style>
  